export const ACTIONS = {
  RECORD_DISABLE_GROUP_CHAT: 'RECORD_DISABLE_GROUP_CHAT',
};

export const recordDisableGroupChat = data => dispatch => {
  dispatch({
    type: ACTIONS.RECORD_DISABLE_GROUP_CHAT,
    payload: data,
  });
};
